import { Api as api } from "../../api";

const prefix = "/transport-operation";

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    transportOperationServiceV1ListFleetTripHistory: build.query<
      TransportOperationServiceV1ListFleetTripHistoryApiResponse,
      TransportOperationServiceV1ListFleetTripHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/tms/api/v1/fleets/${queryArg.fleetId}/trip-history`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
          status: queryArg.status,
          start_date: queryArg.startDate,
          end_date: queryArg.endDate,
          order: queryArg.order,
          order_by: queryArg.orderBy,
        },
      }),
    }),
    transportOperationServiceV1PocElevation: build.mutation<
      TransportOperationServiceV1PocElevationApiResponse,
      TransportOperationServiceV1PocElevationApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/tms/api/v1/poc-elevation`,
        method: "POST",
        body: queryArg.transportOperationPocElevationReq,
      }),
    }),
    transportOperationServiceV1CreateRoute: build.mutation<
      TransportOperationServiceV1CreateRouteApiResponse,
      TransportOperationServiceV1CreateRouteApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/tms/api/v1/route`,
        method: "POST",
        body: queryArg.transportOperationCreateRouteRequest,
      }),
    }),
    transportOperationServiceV1CalculateRoute: build.mutation<
      TransportOperationServiceV1CalculateRouteApiResponse,
      TransportOperationServiceV1CalculateRouteApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/tms/api/v1/route/calculate/${queryArg["type"]}`,
        method: "POST",
        body: queryArg.transportOperationServiceV1CalculateRouteBody,
      }),
    }),
    transportOperationServiceV1SaveCalculation: build.mutation<
      TransportOperationServiceV1SaveCalculationApiResponse,
      TransportOperationServiceV1SaveCalculationApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/tms/api/v1/route/save-calculation/${queryArg["type"]}`,
        method: "POST",
        body: queryArg.transportOperationServiceV1SaveCalculationBody,
      }),
    }),
    transportOperationServiceV1ListTemporaryCalculations: build.query<
      TransportOperationServiceV1ListTemporaryCalculationsApiResponse,
      TransportOperationServiceV1ListTemporaryCalculationsApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/tms/api/v1/route/temp`,
        params: {
          name: queryArg.name,
          page: queryArg.page,
          limit: queryArg.limit,
          vehicleTypeId: queryArg.vehicleTypeId,
        },
      }),
    }),
    transportOperationServiceV1GetTemporaryCalculation: build.query<
      TransportOperationServiceV1GetTemporaryCalculationApiResponse,
      TransportOperationServiceV1GetTemporaryCalculationApiArg
    >({
      query: (queryArg) => ({ url: `${prefix}/tms/api/v1/route/temp/${queryArg.id}` }),
    }),
    transportOperationServiceV1DeleteTemporaryCalculation: build.mutation<
      TransportOperationServiceV1DeleteTemporaryCalculationApiResponse,
      TransportOperationServiceV1DeleteTemporaryCalculationApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/tms/api/v1/route/temp/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    transportOperationServiceV1EditTemporaryRoute: build.mutation<
      TransportOperationServiceV1EditTemporaryRouteApiResponse,
      TransportOperationServiceV1EditTemporaryRouteApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/tms/api/v1/route/temporary-route/${queryArg.id}`,
        method: "PUT",
        body: queryArg.transportOperationServiceV1EditTemporaryRouteBody,
      }),
    }),
    transportOperationServiceV1GetCompatibleRoutes: build.query<
      TransportOperationServiceV1GetCompatibleRoutesApiResponse,
      TransportOperationServiceV1GetCompatibleRoutesApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/tms/api/v1/routes/compatible/so/${queryArg.soId}`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
        },
      }),
    }),
    transportOperationServiceV1GetRoutesByIDs: build.mutation<
      TransportOperationServiceV1GetRoutesByIDsApiResponse,
      TransportOperationServiceV1GetRoutesByIDsApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/tms/api/v1/routes:batch-get`,
        method: "POST",
        body: queryArg.transportOperationGetRoutesByIDsRequest,
      }),
    }),
    transportOperationServiceV1ListToPlanning: build.query<
      TransportOperationServiceV1ListToPlanningApiResponse,
      TransportOperationServiceV1ListToPlanningApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/tms/api/v1/to-planning`,
        params: {
          start_date: queryArg.startDate,
          end_date: queryArg.endDate,
          vehicle_type_id: queryArg.vehicleTypeId,
          customer_id: queryArg.customerId,
        },
      }),
    }),
    transportOperationServiceV1GetDriverWorkOrderInfo: build.query<
      TransportOperationServiceV1GetDriverWorkOrderInfoApiResponse,
      TransportOperationServiceV1GetDriverWorkOrderInfoApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/tms/api/v1/transport-operation/driver/work_order/${queryArg.id}/info`,
      }),
    }),
    transportOperationServiceV1CreateTransportOrder: build.mutation<
      TransportOperationServiceV1CreateTransportOrderApiResponse,
      TransportOperationServiceV1CreateTransportOrderApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/tms/api/v1/transport-order`,
        method: "POST",
        body: queryArg.transportOperationCreateTransportOrderRequest,
      }),
    }),
    transportOperationServiceV1GetAssignRequestSummary: build.query<
      TransportOperationServiceV1GetAssignRequestSummaryApiResponse,
      TransportOperationServiceV1GetAssignRequestSummaryApiArg
    >({
      query: () => ({
        url: `${prefix}/tms/api/v1/transport-order/assign-request/summary`,
      }),
    }),
    transportOperationServiceV1CountTransportOrdersBySoiDs: build.mutation<
      TransportOperationServiceV1CountTransportOrdersBySoiDsApiResponse,
      TransportOperationServiceV1CountTransportOrdersBySoiDsApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/tms/api/v1/transport-order/count-by-soids`,
        method: "POST",
        params: {
          so_ids: queryArg.soIds,
        },
      }),
    }),
    transportOperationServiceV1GetDriverActiveTrip: build.query<
      TransportOperationServiceV1GetDriverActiveTripApiResponse,
      TransportOperationServiceV1GetDriverActiveTripApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/tms/api/v1/transport-order/driver/active-trip`,
        params: {
          date: queryArg.date,
        },
      }),
    }),
    transportOperationServiceV1GetTransportOrderDetail: build.query<
      TransportOperationServiceV1GetTransportOrderDetailApiResponse,
      TransportOperationServiceV1GetTransportOrderDetailApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/tms/api/v1/transport-order/${queryArg.id}/info`,
      }),
    }),
    transportOperationServiceV1ListWorkOrdersByTo: build.query<
      TransportOperationServiceV1ListWorkOrdersByToApiResponse,
      TransportOperationServiceV1ListWorkOrdersByToApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/tms/api/v1/transport-order/${queryArg.id}/work-order`,
      }),
    }),
    transportOperationServiceV1UpdateWorkOrderRoute: build.mutation<
      TransportOperationServiceV1UpdateWorkOrderRouteApiResponse,
      TransportOperationServiceV1UpdateWorkOrderRouteApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/tms/api/v1/transport-order/${queryArg.id}/work-order/${queryArg.woId}`,
        method: "PUT",
        body: queryArg.transportOperationServiceV1UpdateWorkOrderRouteBody,
      }),
    }),
    transportOperationServiceV1GetWorkOrderCalculation: build.query<
      TransportOperationServiceV1GetWorkOrderCalculationApiResponse,
      TransportOperationServiceV1GetWorkOrderCalculationApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/tms/api/v1/transport-order/${queryArg.id}/work-order/${queryArg.woId}/calculation`,
      }),
    }),
    transportOperationServiceV1GetWorkOrderConfig: build.query<
      TransportOperationServiceV1GetWorkOrderConfigApiResponse,
      TransportOperationServiceV1GetWorkOrderConfigApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/tms/api/v1/transport-order/${queryArg.id}/work-order/${queryArg.woId}/get-config`,
      }),
    }),
    transportOperationServiceV1GetWorkOrderRoutes: build.query<
      TransportOperationServiceV1GetWorkOrderRoutesApiResponse,
      TransportOperationServiceV1GetWorkOrderRoutesApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/tms/api/v1/transport-order/${queryArg.id}/work-order/${queryArg.woId}/routes`,
      }),
    }),
    transportOperationServiceV1GetWorkOrderDetail: build.query<
      TransportOperationServiceV1GetWorkOrderDetailApiResponse,
      TransportOperationServiceV1GetWorkOrderDetailApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/tms/api/v1/transport-order/${queryArg.id}/work-order/${queryArg.woId}`,
      }),
    }),
    transportOperationServiceV1UpdateWorkOrderExpensePaid: build.mutation<
      TransportOperationServiceV1UpdateWorkOrderExpensePaidApiResponse,
      TransportOperationServiceV1UpdateWorkOrderExpensePaidApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/tms/api/v1/transport-order/${queryArg.id}/work-order/${queryArg.woId}/expense-paid`,
        method: "PUT",
        body: queryArg.transportOperationServiceV1UpdateWorkOrderExpensePaidBody,
      }),
    }),
    transportOperationServiceV1GetWorkOrderDetailV2: build.query<
      TransportOperationServiceV1GetWorkOrderDetailV2ApiResponse,
      TransportOperationServiceV1GetWorkOrderDetailV2ApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/tms/api/v2/transport-order/${queryArg.id}/work-order/${queryArg.woId}`,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as transportOperationApi };
export type TransportOperationServiceV1ListFleetTripHistoryApiResponse =
  /** status 200 A successful response. */ TransportOperationListFleetTripHistoryResponse;
export type TransportOperationServiceV1ListFleetTripHistoryApiArg = {
  fleetId: string;
  page?: number;
  limit?: number;
  status?: string;
  startDate?: string;
  endDate?: string;
  order?: string;
  orderBy?: string;
};
export type TransportOperationServiceV1PocElevationApiResponse =
  /** status 200 A successful response. */ TransportOperationPocElevationRes;
export type TransportOperationServiceV1PocElevationApiArg = {
  transportOperationPocElevationReq: TransportOperationPocElevationReq;
};
export type TransportOperationServiceV1CreateRouteApiResponse =
  /** status 200 A successful response. */ TransportOperationCreateRouteResponse;
export type TransportOperationServiceV1CreateRouteApiArg = {
  transportOperationCreateRouteRequest: TransportOperationCreateRouteRequest;
};
export type TransportOperationServiceV1CalculateRouteApiResponse =
  /** status 200 A successful response. */ TransportOperationPreciseCalculation;
export type TransportOperationServiceV1CalculateRouteApiArg = {
  type: string;
  transportOperationServiceV1CalculateRouteBody: TransportOperationServiceV1CalculateRouteBody;
};
export type TransportOperationServiceV1SaveCalculationApiResponse =
  /** status 200 A successful response. */ TransportOperationSaveCalculationResponse;
export type TransportOperationServiceV1SaveCalculationApiArg = {
  type: string;
  transportOperationServiceV1SaveCalculationBody: TransportOperationServiceV1SaveCalculationBody;
};
export type TransportOperationServiceV1ListTemporaryCalculationsApiResponse =
  /** status 200 A successful response. */ TransportOperationListTemporaryCalculationsResponse;
export type TransportOperationServiceV1ListTemporaryCalculationsApiArg = {
  name?: string;
  page?: number;
  limit?: number;
  vehicleTypeId?: string;
};
export type TransportOperationServiceV1GetTemporaryCalculationApiResponse =
  /** status 200 A successful response. */ TransportOperationGetTemporaryCalculationResponse;
export type TransportOperationServiceV1GetTemporaryCalculationApiArg = {
  id: string;
};
export type TransportOperationServiceV1DeleteTemporaryCalculationApiResponse =
  /** status 200 A successful response. */ {};
export type TransportOperationServiceV1DeleteTemporaryCalculationApiArg = {
  id: string;
};
export type TransportOperationServiceV1EditTemporaryRouteApiResponse =
  /** status 200 A successful response. */ TransportOperationSaveCalculationResponse;
export type TransportOperationServiceV1EditTemporaryRouteApiArg = {
  id: string;
  transportOperationServiceV1EditTemporaryRouteBody: TransportOperationServiceV1EditTemporaryRouteBody;
};
export type TransportOperationServiceV1GetCompatibleRoutesApiResponse =
  /** status 200 A successful response. */ TransportOperationGetCompatibleRoutesRes;
export type TransportOperationServiceV1GetCompatibleRoutesApiArg = {
  soId: string;
  page?: number;
  limit?: number;
};
export type TransportOperationServiceV1GetRoutesByIDsApiResponse =
  /** status 200 A successful response. */ TransportOperationGetRoutesByIDsResponse;
export type TransportOperationServiceV1GetRoutesByIDsApiArg = {
  transportOperationGetRoutesByIDsRequest: TransportOperationGetRoutesByIDsRequest;
};
export type TransportOperationServiceV1ListToPlanningApiResponse =
  /** status 200 A successful response. */ TransportOperationListToPlanningResponse;
export type TransportOperationServiceV1ListToPlanningApiArg = {
  startDate?: string;
  endDate?: string;
  vehicleTypeId?: string;
  customerId?: string;
};
export type TransportOperationServiceV1GetDriverWorkOrderInfoApiResponse =
  /** status 200 A successful response. */ TransportOperationGetDriverWorkOrderInfoResponse;
export type TransportOperationServiceV1GetDriverWorkOrderInfoApiArg = {
  id: string;
};
export type TransportOperationServiceV1CreateTransportOrderApiResponse =
  /** status 200 A successful response. */ TransportOperationCreateTransportOrderResponse;
export type TransportOperationServiceV1CreateTransportOrderApiArg = {
  transportOperationCreateTransportOrderRequest: TransportOperationCreateTransportOrderRequest;
};
export type TransportOperationServiceV1GetAssignRequestSummaryApiResponse =
  /** status 200 A successful response. */ TransportOperationGetAssignRequestSummaryResponse;
export type TransportOperationServiceV1GetAssignRequestSummaryApiArg = void;
export type TransportOperationServiceV1CountTransportOrdersBySoiDsApiResponse =
  /** status 200 A successful response. */ TransportOperationCountTransportOrdersBySoiDsResponse;
export type TransportOperationServiceV1CountTransportOrdersBySoiDsApiArg = {
  soIds?: string[];
};
export type TransportOperationServiceV1GetDriverActiveTripApiResponse =
  /** status 200 A successful response. */ TransportOperationGetDriverActiveTripResponse;
export type TransportOperationServiceV1GetDriverActiveTripApiArg = {
  date?: string;
};
export type TransportOperationServiceV1GetTransportOrderDetailApiResponse =
  /** status 200 A successful response. */ TransportOperationGetTransportOrderDetailResponse;
export type TransportOperationServiceV1GetTransportOrderDetailApiArg = {
  id: string;
};
export type TransportOperationServiceV1ListWorkOrdersByToApiResponse =
  /** status 200 A successful response. */ TransportOperationListWorkOrdersByToResponse;
export type TransportOperationServiceV1ListWorkOrdersByToApiArg = {
  id: string;
};
export type TransportOperationServiceV1UpdateWorkOrderRouteApiResponse =
  /** status 200 A successful response. */ TransportOperationUpdateWorkOrderRouteResponse;
export type TransportOperationServiceV1UpdateWorkOrderRouteApiArg = {
  id: string;
  woId: string;
  transportOperationServiceV1UpdateWorkOrderRouteBody: TransportOperationServiceV1UpdateWorkOrderRouteBody;
};
export type TransportOperationServiceV1GetWorkOrderCalculationApiResponse =
  /** status 200 A successful response. */ TransportOperationGetWorkOrderCalculationResponse;
export type TransportOperationServiceV1GetWorkOrderCalculationApiArg = {
  id: string;
  woId: string;
};
export type TransportOperationServiceV1GetWorkOrderConfigApiResponse =
  /** status 200 A successful response. */ TransportOperationGetWorkOrderConfigResponse;
export type TransportOperationServiceV1GetWorkOrderConfigApiArg = {
  id: string;
  woId: string;
};
export type TransportOperationServiceV1GetWorkOrderRoutesApiResponse =
  /** status 200 A successful response. */ TransportOperationGetWorkOrderRoutesResponse;
export type TransportOperationServiceV1GetWorkOrderRoutesApiArg = {
  id: string;
  woId: string;
};
export type TransportOperationServiceV1GetWorkOrderDetailApiResponse =
  /** status 200 A successful response. */ TransportOperationGetWorkOrderDetailResponse;
export type TransportOperationServiceV1GetWorkOrderDetailApiArg = {
  id: string;
  woId: string;
};
export type TransportOperationServiceV1UpdateWorkOrderExpensePaidApiResponse =
  /** status 200 A successful response. */ TransportOperationUpdateWorkOrderExpensePaidResponse;
export type TransportOperationServiceV1UpdateWorkOrderExpensePaidApiArg = {
  id: string;
  woId: string;
  transportOperationServiceV1UpdateWorkOrderExpensePaidBody: TransportOperationServiceV1UpdateWorkOrderExpensePaidBody;
};
export type TransportOperationServiceV1GetWorkOrderDetailV2ApiResponse =
  /** status 200 A successful response. */ TransportOperationGetWorkOrderDetailV2Response;
export type TransportOperationServiceV1GetWorkOrderDetailV2ApiArg = {
  id: string;
  woId: string;
};
export type TransportOperationFleetTripHistoryItem = {
  id?: string;
  to_id?: string;
  wo_number?: string;
  to_number?: string;
  customer_id?: string;
  customer_name?: string;
  status?: string;
  date?: string;
};
export type TransportOperationWorkOrdersPagination = {
  currentPage?: number;
  haveNextPage?: boolean;
  havePreviousPage?: boolean;
  limit?: number;
  total?: number;
  totalPage?: number;
};
export type TransportOperationListFleetTripHistoryResponse = {
  trip_history?: TransportOperationFleetTripHistoryItem[];
  metadata?: TransportOperationWorkOrdersPagination;
};
export type ProtobufAny = {
  "@type"?: string;
  [key: string]: any;
};
export type RpcStatus = {
  code?: number;
  message?: string;
  details?: ProtobufAny[];
};
export type TransportOperationDangerSegment = {
  startDistance?: number;
  endDistance?: number;
  length?: number;
  maxGrade?: number;
  avgGrade?: number;
  severity?: string;
};
export type TransportOperationRoutePoint = {
  lat?: number;
  lng?: number;
  elevation?: number;
  cumulativeDistance?: number;
};
export type TransportOperationPocElevationRes = {
  routeSafe?: boolean;
  highesGrade?: number;
  longestContinuousClimb?: number;
  totalElevationGain?: number;
  totalElevationLoss?: number;
  dangerSegments?: TransportOperationDangerSegment[];
  points?: TransportOperationRoutePoint[];
};
export type TransportOperationPocElevationReq = {
  geopath_code?: string;
};
export type TransportOperationRouteCalculationResult = {
  vehicleTypeId?: string;
  routeCalculationId?: string;
};
export type TransportOperationCreateRouteResponse = {
  success?: boolean;
  message?: string;
  routeId?: string;
  calculations?: TransportOperationRouteCalculationResult[];
};
export type TransportOperationCreateRouteInput = {
  name?: string;
  rest_time_minutes?: number;
  load_unload_time_minutes?: number;
  average_speed_full?: number;
  average_speed_empty?: number;
  expected_fuel_price?: number;
  fuel_surcharge_percentage?: number;
  trip_days?: number;
  toll_expense?: number;
  other_expense?: number;
  metadata?: string;
  is_toll?: boolean;
  incentive?: boolean;
  meal_expense?: boolean;
  save_temp?: boolean;
  fix_cost?: boolean;
  trip_duration_on_config?: string;
  rest_empty_time_minutes?: number;
  fuel_surcharge_empty_percentage?: number;
};
export type TransportOperationCreateRouteDropPoint = {
  place?: string;
  placeDescription?: string;
  placeRefId?: string;
  requestedTime?: string;
  detail?: string;
  mapUrl?: string;
  type?: string;
  latitude?: string;
  longitude?: string;
  dropSequence?: number;
};
export type TransportOperationCreateRouteRequest = {
  route?: TransportOperationCreateRouteInput;
  dropPoints?: TransportOperationCreateRouteDropPoint[];
};
export type TransportOperationPreciseSpecs = {
  speed_avg_full_kmh?: number;
  speed_avg_empty_kmh?: number;
  fuel_efficiency?: number;
  fuel_efficiency_empty?: number;
  fuel_efficiency_dry?: number;
  freezer_fuel_efficiency?: number;
};
export type TransportOperationFuelType = {
  id?: string;
  name?: string;
  price_per_liter?: number;
};
export type TransportOperationPreciseVehicleConfig = {
  specs?: TransportOperationPreciseSpecs;
  fuel_type?: TransportOperationFuelType;
};
export type TransportOperationPreciseRateMultipliers = {
  basic_rate?: number;
  incentive_per_km?: number;
  meal_expense?: number;
  fuel_price?: number;
};
export type TransportOperationPreciseLeg = {
  id_drop_point?: string;
  distance_km?: number;
  type?: string;
  trip_duration_hours?: number;
  fuel_needed?: number;
};
export type TransportOperationPreciseTripDetails = {
  total_distance_km?: number;
  total_distance_delivery_km?: number;
  total_distance_non_delivery_km?: number;
  total_trip_duration_hours?: number;
  trip_days?: number;
  legs?: TransportOperationPreciseLeg[];
};
export type TransportOperationPreciseFuelCalculation = {
  base_fuel_needed?: number;
  freezer_driving_fuel?: number;
  freezer_idle_fuel?: number;
  expected_total_fuel_liters?: number;
  fuel_normal?: number;
  fuel_empty?: number;
  fuel_surcharge?: number;
  fuel_surcharge_empty?: number;
  fuel_freezer?: number;
};
export type TransportOperationPreciseFinancialCalculation = {
  total_fuel_cost?: number;
  total_basic_rate?: number;
  total_um?: number;
  meal_expense?: number;
  incentive?: number;
  total_driver_slip?: number;
  toll_expense?: number;
  other_expense?: number;
  total_fuel_normal?: number;
  total_fuel_empty?: number;
  total_fuel_freezer?: number;
  fix_cost?: number;
};
export type TransportOperationPreciseResults = {
  fuel_calculation?: TransportOperationPreciseFuelCalculation;
  financial_calculation?: TransportOperationPreciseFinancialCalculation;
};
export type TransportOperationPreciseCalculation = {
  vehicle_config?: TransportOperationPreciseVehicleConfig;
  rate_multipliers?: TransportOperationPreciseRateMultipliers;
  trip_details?: TransportOperationPreciseTripDetails;
  results?: TransportOperationPreciseResults;
};
export type TransportOperationServiceV1CalculateRouteBody = {
  vehicleModelId?: string;
  vehicle_type_id?: string;
  route?: TransportOperationCreateRouteInput;
  dropPoints?: TransportOperationCreateRouteDropPoint[];
  name?: string;
};
export type TransportOperationSaveCalculationResponse = {
  id?: string;
};
export type TransportOperationServiceV1SaveCalculationBody = {
  vehicleModelId?: string;
  vehicle_type_id?: string;
  route?: TransportOperationCreateRouteInput;
  dropPoints?: TransportOperationCreateRouteDropPoint[];
  name?: string;
};
export type TransportOperationTemporaryRouteItem = {
  id?: string;
  name?: string;
  type?: string;
  price?: number;
  totalKm?: number;
  tripDays?: number;
  origin?: string;
  destination?: string;
  isRoundtrip?: boolean;
  sub_name?: string;
};
export type TransportOperationListTemporaryCalculationsResponse = {
  route?: TransportOperationTemporaryRouteItem[];
  metadata?: TransportOperationWorkOrdersPagination;
};
export type TransportOperationGetTemporaryCalculationResponse = {
  id?: string;
  name?: string;
  type?: string;
  calculationMetadata?: string;
  reqMetadata?: string;
  tripDays?: number;
  origin?: string;
  destination?: string;
  isRoundtrip?: boolean;
  vehicleModelId?: string;
  vehicleModelName?: string;
  freezerModelId?: string;
  freezerModelName?: string;
};
export type TransportOperationServiceV1EditTemporaryRouteBody = {
  vehicleModelId?: string;
  vehicle_type_id?: string;
  route?: TransportOperationCreateRouteInput;
  dropPoints?: TransportOperationCreateRouteDropPoint[];
  type?: string;
  name?: string;
};
export type TransportOperationDriverSlipRange = {
  lowest?: number;
  highest?: number;
};
export type TransportOperationCompatibleRouteItem = {
  id?: string;
  name?: string;
  estimated_distance?: number;
  total_expense?: number;
  trip_days?: number;
  last_used?: string;
  used_count?: number;
  route_calculation_id?: string;
  is_toll?: boolean;
  total_driver_slip?: TransportOperationDriverSlipRange;
};
export type TransportOperationGetCompatibleRoutesRes = {
  success?: boolean;
  message?: string;
  routes?: TransportOperationCompatibleRouteItem[];
  metadata?: TransportOperationWorkOrdersPagination;
};
export type TransportOperationRouteItem = {
  id?: string;
  name?: string;
  estimated_distance?: number;
  rest_time_minutes?: number;
  load_unload_time_minutes?: number;
  average_speed_full?: number;
  average_speed_empty?: number;
  expected_fuel_price?: number;
  fuel_surcharge_percentage?: number;
  toll_expense?: number;
  trip_days?: number;
  geo_path_code?: string;
  origin_lat?: number;
  origin_lng?: number;
  dest_lat?: number;
  dest_lng?: number;
  last_used?: string;
  used_count?: number;
  created_at?: string;
  is_toll?: boolean;
};
export type TransportOperationGetRoutesByIDsResponse = {
  success?: boolean;
  message?: string;
  routes?: TransportOperationRouteItem[];
};
export type TransportOperationGetRoutesByIDsRequest = {
  ids: string[];
};
export type TransportOperationPlanningRouteInfo = {
  origin?: string;
  destination?: string;
};
export type TransportOperationPlanningDriver = {
  id?: string;
  name?: string;
  photo_url?: string;
  phone_number?: string;
};
export type TransportOperationCargo = {
  weight_qty?: number;
  weight_uom?: string;
  temperature_qty?: number;
  temperature_uom?: string;
  product_group?: string;
};
export type TransportOperationPlanningDropPoint = {
  id?: string;
  type?: string;
  standby_time?: string;
  requirement?: string;
  place?: string;
  place_description?: string;
  requested_time?: string;
};
export type TransportOperationPlanningFleetItem = {
  id?: string;
  ordered_fleet_id?: string;
  plate_number?: string;
  driver?: TransportOperationPlanningDriver;
  cargo?: TransportOperationCargo;
  requirements?: string;
  drop_points?: TransportOperationPlanningDropPoint[];
};
export type TransportOperationSoPlanningItem = {
  id?: string;
  route?: TransportOperationPlanningRouteInfo;
  so_number?: string;
  is_round_trip?: boolean;
  is_priority?: boolean;
  status?: string;
  ordered_date?: string;
  vehicle_type?: string;
  customer_name?: string;
  ordered_fleets?: TransportOperationPlanningFleetItem[];
};
export type TransportOperationToPlanningItem = {
  id?: string;
  so_id?: string;
  route?: TransportOperationPlanningRouteInfo;
  to_number?: string;
  is_round_trip?: boolean;
  is_priority?: boolean;
  status?: string;
  operational_expense_paid?: boolean;
  rta?: string;
  total_distance_km?: number;
  vehicle_type_id?: string;
  customer_id?: string;
  customer_name?: string;
  work_order?: TransportOperationPlanningFleetItem[];
};
export type TransportOperationListToPlanningResponse = {
  sales_order?: TransportOperationSoPlanningItem[];
  transport_order?: TransportOperationToPlanningItem[];
};
export type TransportOperationDriverWoInfoRoute = {
  origin_city?: string;
  destination_city?: string;
};
export type TransportOperationGetDriverWorkOrderInfoResponse = {
  id?: string;
  rta?: string;
  route?: TransportOperationDriverWoInfoRoute;
  is_roundtrip?: boolean;
  customer_name?: string;
  progress?: number;
  to_id?: string;
  arrived_at?: string;
};
export type TransportOperationCreateTransportOrderResponse = {
  success?: boolean;
  message?: string;
  transportOrderId?: string;
};
export type TransportOperationCreateToRoute = {
  route_calculation_id?: string;
  name?: string;
  rest_time_minutes?: number;
  load_unload_time_minutes?: number;
  average_speed_full?: number;
  average_speed_empty?: number;
  expected_fuel_price?: number;
  fuel_surcharge_percentage?: number;
  fuel_surcharge_empty_percentage?: number;
  trip_days?: number;
  toll_expense?: number;
  metadata?: string;
  is_toll?: boolean;
};
export type TransportOperationCreateToWorkOrder = {
  orderedFleetId: string;
  route?: TransportOperationCreateToRoute;
  dropPoints?: TransportOperationCreateRouteDropPoint[];
};
export type TransportOperationCreateTransportOrderRequest = {
  soId: string;
  notes?: string;
  workOrders?: TransportOperationCreateToWorkOrder[];
};
export type TransportOperationGetAssignRequestSummaryResponse = {
  approved_count?: number;
  waiting_approval_count?: number;
};
export type TransportOperationCountTransportOrdersBySoiDsResponse = {
  dispatching?: string;
  in_transit?: string;
  delivered?: string;
};
export type TransportOperationDriverActiveTripRoute = {
  origin_city?: string;
  destination_city?: string;
};
export type TransportOperationGetDriverActiveTripResponse = {
  id?: string;
  drop_point_id?: string;
  rta?: string;
  route?: TransportOperationDriverActiveTripRoute;
  is_roundtrip?: boolean;
  customer_name?: string;
  fleet_id?: string;
  lat?: number;
  long?: number;
  type?: string;
  encoded_polyline?: string;
  progress_done?: number;
  progress_total?: number;
  progress_name?: string;
  status?: string;
  drop_point_status?: string;
  next_action_place?: string;
  next_action_type?: string;
  current_action_name?: string;
  current_action_type?: string;
  current_action_address?: string;
  wo_number?: string;
  operational_expense_paid?: boolean;
};
export type TransportOperationToCustomerInfo = {
  id?: string;
  customer_name?: string;
};
export type TransportOperationTosoRef = {
  id?: string;
  so_number?: string;
};
export type TransportOperationToOriginAddress = {
  name?: string;
  map_url?: string;
  description?: string;
};
export type TransportOperationGetTransportOrderDetailResponse = {
  id?: string;
  customer?: TransportOperationToCustomerInfo;
  so_ref?: TransportOperationTosoRef;
  status?: string;
  vehicle_type?: string;
  standby_time?: string;
  origin_address?: TransportOperationToOriginAddress;
};
export type TransportOperationWoNotice = {
  type?: string;
  detail?: string;
};
export type TransportOperationWorkOrderItemByTo = {
  fleet_code?: string;
  plate_number?: string;
  wo_code?: string;
  status?: string;
  operational_expense_paid?: boolean;
  notice?: TransportOperationWoNotice;
};
export type TransportOperationListWorkOrdersByToResponse = {
  work_order?: TransportOperationWorkOrderItemByTo[];
};
export type TransportOperationUpdateWorkOrderRouteResponse = {
  success?: boolean;
  message?: string;
};
export type TransportOperationServiceV1UpdateWorkOrderRouteBody = {
  route: TransportOperationCreateRouteInput;
  dropPoints?: TransportOperationCreateRouteDropPoint[];
};
export type TransportOperationGetWorkOrderCalculationResponse = {
  /** Polymorphic calculation metadata stored as google.protobuf.Struct for
    backward compatibility with existing frontend consumers.
    
    The shape depends on when the calculation was performed:
      - Creation-time (vehicle type only): range-based with {highest, lowest} objects
      - OM-approved (vehicle model known):    precise with flat numeric values
    
    Internally, the usecase layer resolves the variant from the source column
    (wo.metadata for precise, rc.calculation_metadata for range) and maps to
    the flat map representation that consumers expect. */
  calculation?: object;
};
export type TransportOperationRouteConfig = {
  name?: string;
  rest_time_minutes?: number;
  load_unload_time_minutes?: number;
  average_speed_full?: number;
  average_speed_empty?: number;
  expected_fuel_price?: number;
  fuel_surcharge_percentage?: number;
  trip_days?: number;
  toll_expense?: number;
  is_toll?: boolean;
};
export type TransportOperationGetWorkOrderConfigResponse = {
  config?: TransportOperationRouteConfig;
};
export type TransportOperationWoDropPoint = {
  place?: string;
  type?: string;
  requested_time?: string;
  arrival_time?: string;
};
export type TransportOperationGetWorkOrderRoutesResponse = {
  requirement?: string;
  notes?: string;
  temp_category?: string;
  cargo?: TransportOperationCargo;
  drop_points?: TransportOperationWoDropPoint[];
  distance_km?: number;
};
export type TransportOperationGetWorkOrderDetailResponse = {
  fleet_code?: string;
  plate_number?: string;
  wo_code?: string;
  status?: string;
  driver?: TransportOperationPlanningDriver;
  operational_expense_paid?: boolean;
  cargo?: TransportOperationCargo;
  requirement?: string;
  notes?: string;
  temp_category?: string;
  drop_points?: TransportOperationWoDropPoint[];
};
export type TransportOperationUpdateWorkOrderExpensePaidResponse = {
  success?: boolean;
};
export type TransportOperationServiceV1UpdateWorkOrderExpensePaidBody = {
  operational_expense_paid?: boolean;
};
export type TransportOperationGetWorkOrderDetailV2Response = {
  to_number?: string;
  so_number?: string;
  origin_address?: string;
  origin_map_url?: string;
  fleet_code?: string;
  plate_number?: string;
  wo_code?: string;
  status?: string;
  driver?: TransportOperationPlanningDriver;
  operational_expense_paid?: boolean;
  customer?: TransportOperationToCustomerInfo;
  encoded_polyline?: string;
};
export const {
  useTransportOperationServiceV1ListFleetTripHistoryQuery,
  useTransportOperationServiceV1PocElevationMutation,
  useTransportOperationServiceV1CreateRouteMutation,
  useTransportOperationServiceV1CalculateRouteMutation,
  useTransportOperationServiceV1SaveCalculationMutation,
  useTransportOperationServiceV1ListTemporaryCalculationsQuery,
  useTransportOperationServiceV1GetTemporaryCalculationQuery,
  useTransportOperationServiceV1DeleteTemporaryCalculationMutation,
  useTransportOperationServiceV1EditTemporaryRouteMutation,
  useTransportOperationServiceV1GetCompatibleRoutesQuery,
  useTransportOperationServiceV1GetRoutesByIDsMutation,
  useTransportOperationServiceV1ListToPlanningQuery,
  useTransportOperationServiceV1GetDriverWorkOrderInfoQuery,
  useTransportOperationServiceV1CreateTransportOrderMutation,
  useTransportOperationServiceV1GetAssignRequestSummaryQuery,
  useTransportOperationServiceV1CountTransportOrdersBySoiDsMutation,
  useTransportOperationServiceV1GetDriverActiveTripQuery,
  useTransportOperationServiceV1GetTransportOrderDetailQuery,
  useTransportOperationServiceV1ListWorkOrdersByToQuery,
  useTransportOperationServiceV1UpdateWorkOrderRouteMutation,
  useTransportOperationServiceV1GetWorkOrderCalculationQuery,
  useTransportOperationServiceV1GetWorkOrderConfigQuery,
  useTransportOperationServiceV1GetWorkOrderRoutesQuery,
  useTransportOperationServiceV1GetWorkOrderDetailQuery,
  useTransportOperationServiceV1UpdateWorkOrderExpensePaidMutation,
  useTransportOperationServiceV1GetWorkOrderDetailV2Query,
} = injectedRtkApi;
